export enum TypeOriginSystemEnum {
    INTERNAL = 'SOLUÇÕES ALFASU',
    EXTERNAL = 'SOLUÇÕES EXTERNO',
}
